import { isObj } from '../type'

// 剔除对象中的某些字段
export const omit = (obj: any, arr: string[] | undefined, deep = false) => {
    if (!isObj(obj) || !arr?.length) {
        return obj
    }

    return Object.keys(obj).reduce((t, c) => {
        if (!arr.includes(c)) {
            if (deep) {
                // 深度过滤
                t[c] = omit(obj[c], arr, deep)
            } else {
                t[c] = obj[c]
            }
        }

        return t
    }, {})
}
